import { useFFContext } from '@/components/OpenFeature/hooks/useFFContext';
import { Wrapper } from '@/components/OpenFeature/Wrapper';
import { TransactionItemDetail } from '@/features/transaction_items/Detail/TransactionItemDetail';
import { TransactionItemDetailEditProvider } from '@/features/transaction_items/Detail/context/TransactionItemDetailEdit';
import { OpenFeatureProvider } from '@moneyforward/user-flex-feature-hooks';
import { FC, memo } from 'react';

const TransactionItemDetailPage: FC = memo(() => {
  const context = useFFContext();
  return (
    <Wrapper isProto={false}>
      <OpenFeatureProvider
        pollInterval={-1}
        context={context}
        domain='flexible-validation-for-invoice-transaction'
      >
        <TransactionItemDetailEditProvider>
          <TransactionItemDetail />
        </TransactionItemDetailEditProvider>
      </OpenFeatureProvider>
    </Wrapper>
  );
});

TransactionItemDetailPage.displayName = 'TransactionItemDetailPage';
export default TransactionItemDetailPage;
